import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { NoteConceptDetailResponse } from 'src/app/models/invoicing/note-concept-detail-response.mode';
import { NoteConceptModel } from 'src/app/models/invoicing/note-concept.model';
import { NoteModel } from 'src/app/models/invoicing/note.model';
import { NoteConceptService } from 'src/app/services/invoicing/note-concept.service';
import { NoteDetailService } from 'src/app/services/invoicing/note-detail.service';
import { NoteService } from 'src/app/services/invoicing/note.service';

@Component({
  selector: 'app-register-note-detail-concept',
  templateUrl: './register-note-detail-concept.component.html',
  styleUrls: ['./register-note-detail-concept.component.scss'],
  standalone: false
})
export class RegisterNoteDetailConceptComponent implements OnChanges {

  @Input() noteConceptDetailResponse: NoteConceptDetailResponse = new NoteConceptDetailResponse();
  @Input() noteModel: NoteModel = new NoteModel();
  @Output() isFormView = new EventEmitter<boolean>();
  @Output() newNoteConceptDetailResponse = new EventEmitter<NoteConceptDetailResponse>();
  @Output() noteContract = new EventEmitter<NoteModel>();
  @Output() updateListDetail = new EventEmitter<boolean>();

  conceptInvoicingId: number = 0;
  formNoteConcept: FormGroup = new FormGroup({})
  listConceptInvoicing: any[] = [];
  listStore: any[] = [];
  noteConceptContract: NoteConceptModel = new NoteConceptModel();
  noteConceptId: number = 0;
  storeId: number = 0;

  constructor(private formBuilder: FormBuilder,
    private noteService: NoteService,
    private noteDetailService: NoteDetailService,
    private noteConceptService: NoteConceptService,
    private toastr: ToastrService) {
    this.validateForm(this.noteConceptDetailResponse);
  }

  async ngOnChanges(changes: SimpleChanges) {
    let noteModel = changes["noteModel"];
    if (noteModel) {
      if (this.noteModel.noteId != 0) await this.getConceptInvoicingList();
    }
    let noteConceptDetailResponse = changes["noteConceptDetailResponse"];
    if (noteConceptDetailResponse && !noteConceptDetailResponse.firstChange) {
      if (this.noteConceptDetailResponse.noteConceptId == 0) {
        this.createNewNoteDetail();
      } else {
        this.updateListDetail.emit(true);
        this.noteConceptId = this.noteConceptDetailResponse.noteConceptId;
        this.validateForm(this.noteConceptDetailResponse);
      }
      setTimeout(() => this.formNoteConcept.controls["invoicedValue"].disable(), 100);
      setTimeout(() => this.formNoteConcept.controls["invoiceResidue"].disable(), 100);
    }
  }

  clearForm(closeForm: boolean) {
    this.conceptInvoicingId = 0;
    this.storeId = 0;
    let modelNoteConceptDetailResponse = new NoteConceptDetailResponse;
    this.newNoteConceptDetailResponse.emit(modelNoteConceptDetailResponse);
    this.isFormView.emit(closeForm);
  }

  createNewNoteDetail() {
    this.validateForm(this.noteConceptDetailResponse);
    this.noteConceptId = 0;
  }

  async getConceptInvoicingList(): Promise<void> {
    try {
      if (this.noteModel.invoiceId !== null)
        this.listConceptInvoicing = await firstValueFrom(this.noteDetailService.getAllConceptInvoicingForSelectAsync(this.noteModel.invoiceId));
    } catch (error) {
      console.error('Error al obtener la lista de conceptos de facturación:', error);
    }
  }

  async getStoresList(): Promise<void> {
    if (this.noteModel.invoiceId !== null && this.conceptInvoicingId !== 0) {
      try {
        this.listStore = await firstValueFrom(this.noteDetailService.getAllStoreForSelectAsync(this.noteModel.invoiceId, this.conceptInvoicingId));
      } catch (error) {
        console.error('Error al cargar lista de bodegas:', error);
      }
    }
  }

  async getConceptInvoicing(conceptInvoicingId: number | null, reload: boolean) {
    if (conceptInvoicingId != null && conceptInvoicingId != 0) {
      let conceptInvoicing = this.listConceptInvoicing.find(x => x.value == conceptInvoicingId);
      if (conceptInvoicing) {
        this.conceptInvoicingId = conceptInvoicingId;
        await this.getStoresList();
      } else {
        this.conceptInvoicingId = 0;
        return;
      }
    } else {
      this.conceptInvoicingId = 0;
    }
    if (reload) {
      let modelNoteConcept = new NoteConceptDetailResponse;
      modelNoteConcept.conceptInvoicingId = this.conceptInvoicingId;
      modelNoteConcept.storeId = 0;
      this.storeId = 0;
      this.newNoteConceptDetailResponse.emit(modelNoteConcept);
    }
  }

  async getStore(storeId: number | null, reload: boolean) {
    if (storeId != null && storeId !== 0) {
      const store = this.listStore.find(x => x.value == storeId);
      if (!store) {
        this.storeId = 0;
        this.formNoteConcept.controls["storeId"].patchValue(0);
        return;
      }
      this.storeId = storeId;
      this.formNoteConcept.controls["storeId"].patchValue(storeId);
      if (reload) this.getNoteConceptByKeys();
    } else {
      this.storeId = 0;
      this.formNoteConcept.controls["storeId"].patchValue(0);
      if (reload) {
        const modelNoteConcept = new NoteConceptDetailResponse();
        modelNoteConcept.conceptInvoicingId = this.conceptInvoicingId;
        modelNoteConcept.storeId = 0;
        this.newNoteConceptDetailResponse.emit(modelNoteConcept);
      }
    }
  }

  async getNoteById(noteById: number) {
    try {
      const response = await firstValueFrom(this.noteService.getNoteById(noteById));
      this.noteContract.emit(response);
    } catch (error) {
      console.error('Error al buscar la nota por id en registro nota detalle.', error);
    }
  }

  async getNoteConceptByKeys() {
    if (this.conceptInvoicingId != 0 && this.storeId != 0) {
      try {
        const response = await firstValueFrom(this.noteConceptService.getNoteConceptByKeys(this.noteModel.noteId,
          this.conceptInvoicingId, this.storeId));
        this.newNoteConceptDetailResponse.emit(response);
      } catch (error) {
        console.error('Error al buscar la nota concepto por claves en registro nota detalle.', error);
        let modelNoteConcept = new NoteConceptDetailResponse;
        modelNoteConcept.conceptInvoicingId = this.conceptInvoicingId;
        modelNoteConcept.storeId = this.storeId;
        this.newNoteConceptDetailResponse.emit(modelNoteConcept);
      }
    }
  }

  async send() {
    //Asigno la clave de la Nota
    this.formNoteConcept.controls["noteId"].setValue(this.noteModel.noteId);
    if (this.formNoteConcept.valid) {
      let modelNoteConcept = this.formNoteConcept.value as NoteConceptDetailResponse;
      if (this.noteConceptId == 0) {
        let noteConceptModel: NoteConceptModel = new NoteConceptModel();
        noteConceptModel.noteId = modelNoteConcept.noteId;
        noteConceptModel.conceptInvoicingId = modelNoteConcept.conceptInvoicingId;
        noteConceptModel.storeId = modelNoteConcept.storeId;
        noteConceptModel.value = modelNoteConcept.value;
        noteConceptModel.note = this.noteModel;
        noteConceptModel.createDate = new Date().toISOString();
        try {
          const response = await firstValueFrom(this.noteConceptService.createNoteConcept(noteConceptModel));
          this.toastr.success('El detalle de la Nota fue creado exitosamente.', '', {
            timeOut: 5000, progressBar: true, closeButton: true
          });
          this.getNoteById(response.noteId);
          this.noteConceptContract = new NoteConceptModel();
          this.clearForm(false);
          this.updateListDetail.emit(true);
        } catch (error) {
          console.error('Error al crear el detalle de nota concepto.', error);
        }
      } else {
        this.noteConceptContract = await firstValueFrom(this.noteConceptService.getNoteConceptById(modelNoteConcept.noteConceptId));
        this.noteConceptContract.value = modelNoteConcept.value;
        try {
          const response = await firstValueFrom(this.noteConceptService.updateNoteConcept(this.noteConceptContract));
          this.toastr.success('El detalle de la Nota fue modificado exitosamente.', '', {
            timeOut: 5000, progressBar: true, closeButton: true
          });
          this.getNoteById(response.noteId);
          this.noteConceptContract = new NoteConceptModel();
          this.clearForm(false)
          this.updateListDetail.emit(true);
        } catch (error) {
          console.error('Error al editar el detalle de nota concepto.', error);
          this.updateListDetail.emit(true);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: any = {
      conceptInvoicingId: 'El campo "Concepto facturacion" es obligatorio.',
      storeId: 'El campo "Bodega" es obligatorio.',
      invoicedValue: 'El campo "Vr.Facturado" es obligatorio.',
      invoiceResidue: 'El campo "Vr.Saldo" es obligatorio.',
      value: 'El campo "Vr.Total" es obligatorio.',
    };

    Object.keys(controlMessages).forEach(control => {
      if (this.formNoteConcept.controls[control].invalid) {
        this.toastr.warning(controlMessages[control], 'Atención', {
          timeOut: 5000,
          progressBar: true,
          closeButton: true
        });
      }
    });
  }

  async validateForm(noteConceptDetailResponse: NoteConceptDetailResponse) {
    this.formNoteConcept = this.formBuilder.group({
      noteConceptId: [noteConceptDetailResponse.noteConceptId, []],
      noteId: [noteConceptDetailResponse.noteId, [Validators.required, Validators.min(1)]],
      conceptInvoicingId: [noteConceptDetailResponse.conceptInvoicingId, [Validators.required, Validators.min(1)]],
      storeId: [noteConceptDetailResponse.storeId, [Validators.required, Validators.min(1)]],
      invoicedValue: [noteConceptDetailResponse.invoicedValue, []],
      invoiceResidue: [noteConceptDetailResponse.invoiceResidue, []],
      value: [noteConceptDetailResponse.value, [Validators.required, Validators.min(1)]]
    });
    if (noteConceptDetailResponse.noteConceptId != 0) {
      await this.getConceptInvoicing(this.noteConceptDetailResponse.conceptInvoicingId, false);
      await this.getStore(this.noteConceptDetailResponse.storeId, false);
    }
  }
}